import React, { useEffect, useState } from 'react';
import { InputNumber } from 'antd';
import { useTranslation } from 'react-i18next';

const ContextMenu = ({
  position,
  closeMenu,
  togglePumpState,
  arrIndexPump,
  dataDiagram,
  positionKey,
  handleSaveFrequency,
  togglePumpMode,
  pumpMode,
  inverter,
  setInverter,
}) => {

  const { t } = useTranslation();
  const [isChecked, setChecked] = useState(false);
  const [frequency, setFrequency] = useState(0);

  const contextPoint = dataDiagram?.filter(
    (item) => item.topLeftPoint.x === positionKey
  );

  let indexPump;
  if (
    contextPoint[0].type === 'van' ||
    contextPoint[0].type === 'pump' ||
    contextPoint[0].type === 'vf' ||
    contextPoint[0].type === 'pt'
  ) {
    indexPump = arrIndexPump.find(
      (elm) => elm[0].index === contextPoint[0].number
    );
  }

  useEffect(() => {
    if (indexPump) {
      setChecked(true);
    }
  }, [arrIndexPump]);

  useEffect(() => { }, [isChecked]);

  const handleCloseMenu = (option) => () => closeMenu(option);

  const handleOptionSelectedOn = () => {
    setChecked(!isChecked);
    togglePumpState(true, contextPoint[0].number - 1);
  };

  const handleOptionSelectedOff = () => {
    setChecked(!isChecked);
    togglePumpState(false, contextPoint[0].number - 1);
  };

  const handleOntionSelectedModeOn = () => {
    togglePumpMode(true, contextPoint[0].number - 1);
  };

  const handleOntionSelectedModeOff = () => {
    togglePumpMode(false, contextPoint[0].number - 1);
  };

  const handleUpdateFrequency = () => {
    handleSaveFrequency(contextPoint[0].number, frequency);
    let newInverter = [...inverter];
    newInverter[contextPoint[0].number - 1] = frequency;
    setInverter(newInverter);
  };

  return (
    <div
      id="menu-diagram"
      style={{
        position: 'absolute',
        zIndex: 99,
        left: position?.x,
        top: position?.y,
      }}
    >
      <div className="close" onClick={handleCloseMenu(false)}>
        x
      </div>
      <>
        {contextPoint[0].type === 'vf' && (
          <div className="frequency">
            <div>
              <strong>{t('frequency')}:</strong>
              <InputNumber
                defaultValue={inverter[contextPoint[0].number - 1]}
                style={{ width: 50, margin: '0 5px', fontSize: 11 }}
                size="small"
                min={0}
                onChange={(e) => setFrequency(e)}
              />
              Hz
            </div>
            <button className="btn-update-hz" onClick={handleUpdateFrequency}>
              {t('update')}
            </button>
          </div>
        )}
        <div className="manual">
          <button
            disabled={pumpMode[contextPoint[0].number - 1]}
            className={
              pumpMode[contextPoint[0].number - 1]
                ? `button1 button1-enabal btn-disable`
                : `button1`
            }
            onClick={handleOntionSelectedModeOn}
          >
            {t('auto')}
          </button>
          <button
            disabled={!pumpMode[contextPoint[0].number - 1]}
            className={
              !pumpMode[contextPoint[0].number - 1]
                ? `button2 button2-enabal btn-disable`
                : `button2`
            }
            onClick={handleOntionSelectedModeOff}
          >
            {t('manual')}
          </button>
        </div>
        {!pumpMode[contextPoint[0].number - 1] && (
          <div className="status">
            <button
              disabled={isChecked}
              className={
                isChecked ? `button1 button1-hover btn-disable` : `button1`
              }
              onClick={handleOptionSelectedOn}
            >
              {t('on')}
            </button>
            <button
              disabled={!isChecked}
              className={
                !isChecked ? `button2 button2-hover btn-disable` : `button2`
              }
              onClick={handleOptionSelectedOff}
            >
              {t('off')}
            </button>
          </div>
        )}
      </>
    </div>
  );
};

export default ContextMenu;
